<div class="column-header-group" *ngIf="!(isLoaded | async)">&nbsp;</div>
<div class="column-header-group" *ngIf="isLoaded | async">
    <div *ngFor="let ch of columnHeaders" #columnRefs [ngClass]="ch.class">
        <span *ngIf="ch.sortable" (click)="onClickColumn(ch)" [class.active]="ch.active" [class.up]="uiDirection === 1"
              [class.down]="uiDirection === -1">
            {{ch.labelKey | translate}}<span class="fas fa-fw"></span>
        </span>
        <span *ngIf="!ch.sortable">
            {{ch.labelKey | translate}}
        </span>
    </div>
</div>
